import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"rgba(142, 142, 142, 0.84)","font-weight":"bold"}
}

import { onMounted, ref } from 'vue';
  import { useApp } from '@/hooks/useApp';
  import { appStore } from '@/store/modules/app';
  import { useAppInfo } from '@/hooks/useAppInfo';
  import { DialogConfig } from '@/components/WeDialog/types';
  import { required } from '@/utils/validate';
  import { get_model_file_list, upload_model_file, delete_model_file } from '@/api/erp-more';
  
export default /*#__PURE__*/_defineComponent({
  props: {
    itemId: { default: 0 },
    modelName: { default: '' },
    fileType: { default: undefined },
    canEdit: { default: false },
    tip: { default: '无' }
  },
  emits: ['doAfterhandleFile'],
  setup(__props: any, { emit }) {

const props = __props as { itemId: number, modelName: string, fileType: any, canEdit: boolean, tip: string }

  const { $showAlert, $showDialog } = useApp();
  const { apiRoot } = useAppInfo();
  
  
  const showFileIcon = ref(false);
  const file_list = ref<Recordable[]>([]);
  const initFile = () => {
    const params = { item_id: props.itemId, model_name: props.modelName };
    if (props.fileType !== undefined) {
      params['file_type'] = props.fileType;
    }
    get_model_file_list(params).then((res: Recordable[]) => {
      file_list.value = res;
      emit('doAfterhandleFile', { num: file_list.value.length, fileType: props.fileType });
    });
  };
  onMounted(() => {
    initFile();
  });
  const openFile = (file_code) => {
    window.open(`${apiRoot.value}/inner_file/${file_code}`);
  };
  const deleteFile = (file) => {
    $showAlert('Warning', '确定删除此文件？', () => {
      delete_model_file({ file_id: file.id }).then(() => {
        appStore.SET_ALERT_CONFIG(null);
        initFile();
      });
    });
  };
  const openUploadFileDialog = () => {
    const blocks = [
      {
        type: 'localfile',
        result: 'file_list',
        mode: 'multiple',
        label: '选择上传的文件',
        rules: [required('string', '请选择文件', 'blur')],
      },
    ];
    const config: DialogConfig = {
      title: '上传文件',
      blocks: blocks,
      width: '400px',
      labelCol: '120px',
      callback: (result) => {
        const params = { item_id: props.itemId, model_name: props.modelName };
        if (props.fileType !== undefined) {
          params['file_type'] = props.fileType;
        }
        upload_model_file({
          data: { ...result, ...params },
        }).then(() => {
          appStore.SET_WE_DIALOG(null);
          initFile();
        });
      },
    };
    $showDialog(config);
  };

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", {
    onMouseover: _cache[1] || (_cache[1] = ($event: any) => (showFileIcon.value = true)),
    onMouseout: _cache[2] || (_cache[2] = ($event: any) => (showFileIcon.value = false))
  }, [
    (file_list.value && file_list.value.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(file_list.value, (file) => {
            return (_openBlock(), _createElementBlock("span", {
              key: file.id
            }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (openFile(file.rd_file_code)),
                style: _normalizeStyle(file.style)
              }, _toDisplayString(file.rd_file_name), 13, _hoisted_2),
              _withDirectives(_createVNode(_component_svg_icon, {
                iconName: "CloseOutlined",
                onClick: ($event: any) => (deleteFile(file)),
                style: {"font-size":"16px"}
              }, null, 8, ["onClick"]), [
                [_vShow, __props.canEdit && showFileIcon.value]
              ]),
              (file_list.value.indexOf(file) < file_list.value.length - 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, ","))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.canEdit ? '-' : __props.tip), 1)),
    _withDirectives(_createVNode(_component_svg_icon, {
      iconName: "PlusOutlined",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openUploadFileDialog())),
      style: {"color":"#4885ed"}
    }, null, 512), [
      [_vShow, __props.canEdit]
    ])
  ], 32))
}
}

})